import DeleteIcon from '@mui/icons-material/Delete';

import { Button, Stack } from '@src/components';
import { ALERT_ACTIONS } from '@src/context/constants';
import { useAlert } from '@src/context/hooks';
import { Form, Submit} from '@src/corelib/forms/generic';
import { createSchema, Yup } from '@src/corelib/validation';
import { formatDateRange } from '@src/utils';
import { toUtcDate } from '@src/utils';

import useAbsencesTimeline from './../../../hooks';
import EventFormFieldset from './Fields';


const schema = createSchema({
  date_from: Yup.date().required('This field is required'),
  date_to: Yup.date().nullable(),
  acti_type: Yup.string().required('This field is required'),
  acti_tentative: Yup.boolean(),

});

export default function EventForm({hoursView}) {
  const {
    selectedSlot,
    setSelectedSlot,
    book,
    selectedData,
    remove,
  } = useAbsencesTimeline();
  const alert = useAlert();

  const getEndDate = (values) => {
    if (hoursView || !values.date_to) { 
      return toUtcDate(values.date_from);
    };
    return toUtcDate(values.date_to);
  };
  const onSubmit = async (values) => {
    const payload = {
      ...values,
      acti_user: selectedSlot.user_id,
      date_to: getEndDate(values),
    };

    if (!selectedSlot.absences_ids.length) {
      return book(payload);
    }

    const {date_from, date_to} = selectedSlot;
    const { action } = await alert.open({
      title: 'Warning',
      children: 
            `You are about to overide existing absence events from:
             ${formatDateRange(date_from, date_to)}`,
      slotProps: {
        confirmButton: { label: 'OK' },
        cancelButton: { label: 'Cancel' },
      },
    });
    if (action === ALERT_ACTIONS.CONFIRM) {
      return book(payload);
    }

  };
  const deleteAbsences = async () => { 
    if (selectedSlot) {
      if (selectedSlot.absences_ids.length) {
        const {date_from, date_to} = selectedSlot;
        const { action } = await alert.open({
          title: 'Warning',
          children: 
            `Are you sure you want to remove absence events from:
             ${formatDateRange(date_from, date_to)}`,
          slotProps: {
            confirmButton: { label: 'Delete' },
            cancelButton: { label: 'Cancel' },
          },
        });
        if (action === ALERT_ACTIONS.CONFIRM) {
          remove(selectedSlot.absences_ids);
        }
      }
      else {
        setSelectedSlot(null); 
      }
    } 
  };

  return (
    <Form schema={schema} defaultValues={selectedData} onSubmit={onSubmit}>
      <EventFormFieldset data={selectedData} hoursView={hoursView} />

      <Stack direction="row" justifyContent="space-between">
        <Submit
          variant="contained"
          color="primary"
          loadingPosition="start"
        >
          Book
        </Submit>


        <Button variant="outlined" sx={Stylesheet.delete} onClick={deleteAbsences}>
          <DeleteIcon />
        </Button>

        <Button disabled variant="contained">Approve</Button>

      </Stack>
 
    </Form>
  );
}

const Stylesheet = {
  'delete': (theme) => ({
    minWidth: '30px',
    width: '30px',
    padding: '10px 20px',
    '&:hover': {
      color: theme.palette.red[500],
    },
  }),
};
